import zhCnTranslation from './locales/zh-CN/translation.json';
import zhHkTranslation from './locales/zh-HK/translation.json';
import enUsTranslation from './locales/en-US/translation.json';
import thTranslation from './locales/th/translation.json';
import myTranslation from './locales/my/translation.json';
import hiTranslation from './locales/hi/translation.json';
import idTranslation from './locales/id/translation.json';
import itTranslation from './locales/it/translation.json';
import kmTranslation from './locales/km/translation.json';
import msTranslation from './locales/ms/translation.json';
import viTranslation from './locales/vi/translation.json';

export type TLang = 'zh-CN' | 'zh-HK' | 'en-US' | 'th' | 'my' | 'hi' | 'id' | 'it' | 'km' | 'ms' | 'vi';

type I18nType = {
  t(key: string, params?: Record<string, string | number> | undefined): string;
  addLangData(record: Record<string, string>, lang: TLang): void;
};

const translations: Record<TLang, Record<string, string>> = {
  'zh-CN': zhCnTranslation as Record<string, string>, // 简体中文
  'zh-HK': zhHkTranslation as Record<string, string>, // 繁体中文
  'en-US': enUsTranslation as Record<string, string>, // 英文
  th: thTranslation as Record<string, string>, // 泰文
  my: myTranslation as Record<string, string>, // 缅甸文
  hi: hiTranslation as Record<string, string>, // 印地语
  id: idTranslation as Record<string, string>, // 印度尼西亚语
  it: itTranslation as Record<string, string>, // 意大利语
  km: kmTranslation as Record<string, string>, // 高棉语
  ms: msTranslation as Record<string, string>, // 马来语
  vi: viTranslation as Record<string, string>, // 越南语
};

let currentLang: TLang = 'en-US';
const userInfo = {
  email: '',
  uid: '',
  phone: '',
};

/** 内置 fallback 实现，当外部未注入 i18n 时使用 */
const localI18n: I18nType = {
  t(key: string, params?: Record<string, string | number>): string {
    const dict = translations[currentLang] ?? translations['en-US'];
    let text = (dict[key] ?? translations['en-US'][key] ?? key) as string;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v));
      });
    }
    return text;
  },
  addLangData(record: Record<string, string>, lang: TLang) {
    // const short = lang.startsWith('en') ? 'en' : lang.startsWith('zh') ? 'zh' : lang;
    translations[lang] = { ...translations[lang], ...record };
  },
};

let _i18n: I18nType = localI18n;

/** 外部注入 i18n 实现（parent app 调用） */
export default function init(i18n: I18nType) {
  _i18n = i18n;
}

/**
 * 根据 common.language 设置当前语言
 * en-US → en，zh-CN → zh，th → th，my → my，其他 → en
 */
export function setLanguage(lang: TLang) {
  currentLang = lang;
}

export const i18n = {
  t: (key: string, value?: Record<string, any>) => {
    return _i18n?.t(key, value) || key;
  },
};

export const t = i18n.t;

/** 各语言里这个文案的写法，再加上当前 t()。长的在前，避免短前缀先命中。 */
export function translationVariants(key: string): string[] {
  const values = new Set<string>();
  const current = t(key);
  if (current && current !== key) values.add(current);
  Object.values(translations).forEach((dict) => {
    const text = dict[key];
    if (text) values.add(text);
  });
  return [...values].sort((a, b) => b.length - a.length);
}
